import classNames from 'classnames';
import type { CSSProperties } from 'react';
import React, { useEffect } from 'react';

import type { ImageProps } from './../../bundled-dependencies/wix-image';
import { Image as ImageComp, initCustomElement } from './../../bundled-dependencies/wix-image';
import type { MediaUploadError } from './../../ricos-content';
import type { TFunction } from './../../ricos-types';

import styles from './Image-scss';
import MediaItemErrorMsg from './MediaItemErrorMsg';

let wixImageInitialized = false;

type Props = Exclude<ImageProps, 'id' | 'containerId'> & {
  id?: string | number;
  containerProps?: {
    className?: string;
    containerId?: string;
    style?: CSSProperties;
    dataHook?: string;
  };
  error?: {
    t: TFunction;
    message: MediaUploadError;
  };
};

const Image = (props: Props) => {
  if (!wixImageInitialized) {
    // To not break editor
    initCustomElement();
    wixImageInitialized = true;
  }
  const { containerProps, error, ...imageProps } = props;
  const [shouldUseLQIP, setShouldUseLQIP] = React.useState(true);

  useEffect(() => {
    const handleBeforePrint = () => {
      setShouldUseLQIP(false);
    };

    window.addEventListener('beforeprint', handleBeforePrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
    };
  }, []);

  return (
    <div
      style={containerProps?.style}
      id={containerProps?.containerId}
      className={containerProps?.className}
      data-hook={containerProps?.dataHook}
    >
      <ImageComp
        {...imageProps}
        className={classNames(styles.image, imageProps.className)}
        shouldUseLQIP={shouldUseLQIP}
      />
      {error && <MediaItemErrorMsg error={error.message} t={error.t} />}
    </div>
  );
};

export default Image;
